// src/modules/studentTransfer/config.js
import WizardTopHeader from "../../components/wizard/Topheader";
import { endpoint } from "../../views/pages/manage/common/constant";
import SearchStudent from "./components/searchStudent";
import SelectStudentWrapper from "./components/selectStudent/SelectStudentWrapper";
// import SelectStudent from "./components/selectStudent";
import TransferDetails from "./components/transferDetails";
import VerifyPayments from "./components/verifyPayments";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const TRANSFER_NOT_ELIGIBLE_BU_LIST = ["DW005", "IC006" , "DW007"] ;

const filterNotEligibleBUs = (dropdown  = [])=>{
    return dropdown.filter(item=>!TRANSFER_NOT_ELIGIBLE_BU_LIST.includes(item.label))
}
export const studentTransferListConfig = {
  resource: "users",
  title: "User Management",
  pageSize: 10,

  columns: [
    { key: "employeeId", label: "Employee ID", sortable: true },
    { key: "fullName", label: "Full Name", sortable: true },
    { key: "email", label: "Email" },
    { key: "designation", label: "Designation" },
    { key: "department", label: "Department" },
    { key: "status", label: "Status", filterable: true },
  ],

  filters: [
    { key: "fullName", type: "search", placeholder: "Search by name" },
    { key: "status", type: "select", options: ["Active", "Inactive"] },
  ],

  onNew: (history) => history.push("/studentTransfer/add"),
  onSync: () => fetch("/api/users/sync"),

  actions: (row, history) => [
    {
      label: "Edit",
      onClick: () => history.push(`/studentTransfer/edit/${row.id}`),
    },
    {
      label: "Give Access",
      onClick: () => history.push(`/studentTransfer/${row.id}/access`),
    },
  ],
};
export const getDropdowns = async () => {
  const dropdown = await Promise.all([
    dropdownMapping(endpoint?.term?.getAllActive, "termDispValue", "id"),

    dropdownMapping(
      endpoint.academic_career.getAllActive,
      "academicCareerDispValue",
      "id"
    ),
    dropdownMapping(
      endpoint.academic_group.getAllActive,
      "academicGroupDispValue",
      "id"
    ),
    dropdownMapping(
      endpoint.courseCatelogMapping.getAllActiveCourseIds,
      "courseIds"
    ),
    dropdownMapping(
      endpoint.businessArea.getAllActiveV2,
      "businessAreaDispValue",
      "id",
      "businessAreaDesc"
    ),
    dropdownMapping(
      endpoint.businessArea.getAllActiveBUwithoutSecurity,
      "businessAreaDispValue",
      "id",
      "businessAreaDesc"
    ),
  ]);

  return {
    term: dropdown[0],
    academicCareer: dropdown[1],
    stream: dropdown[2],
    courseIds: dropdown[3],
    businessAres: filterNotEligibleBUs(dropdown[4]),
    businessAresWithoutSecurity: (dropdown[5]),

  };
};

export const studentTransferWizardConfig = {
  resource: "users",
  api: {
    fetch: (id) => `/api/users/${id}`,
    create: () => `/api/users`,
    update: (id) => `/api/users/${id}`,
  },
  searchWizard: {
    isShow: true,
    component: SearchStudent,
  },
  fetchDropdown: getDropdowns,
  initialValues: {
    selectedStudent: "",
    transferDetails: "",
    paymentDetails: "",
    transferDetails: "",
    paymentDetails: "",
    searchStudentsListing: {
      list: [],
    },
    searchStudentsFilters: {},
  },
  steps: [
    {
      id: "selectStudent",
      label: "Select Student",
      component: SelectStudentWrapper,
    },
    {
      id: "transferDetails",
      label: "Transfer details",
      component: TransferDetails,
    },
    {
      id: "verifyPayments",
      label: "Verify payments",
      component: VerifyPayments,
    },
  ],
  topHeader : WizardTopHeader
};
